<template>
    <div class="grid__content">
        <div class="grid__navigator black-overlay">
            <scrollbar class="profile-scroll">
                <div class="profile_blockWidget profile_blockWidget_big-column">
                    <div class="profile_blockWidget-image">
                        <div class="profile_blockWidget-imageItem">
                            <a href="https://iqquantum.com/files/diplom_1.pdf" target="_blank">
                                <img src="../assets/img/diplom_1.png">
                            </a>
                        </div>
                        <div class="profile_blockWidget-imageItem">
                            <a href="https://iqquantum.com/files/diplom_2.pdf" target="_blank">
                                <img src="../assets/img/diplom_2.png">
                            </a>
                        </div>
                    </div>
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-wrap">
                            <div class="profile_blockWidget-title">
                                Наши атестаты
                            </div>
                            <div class="profile_blockWidget-subtitle">
                                <a href="http://www.cbr.ru/finmarket/supervision/sv_validation/att_check/" target="_blank">
                                    Проверка статуса<br>квалифицированного атестата
                                </a>
                            </div>
                        </div>
                        <div class="profile_blockWidget-ico">
							<svg-icon icon-class="icon icon--inline mt-20" icon-name="icon-arrow-next" icon-size="0 0 30 30" icon-fill="#718DA8"></svg-icon>
						</div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_mini">
                    <div class="profile_blockWidget-bigIcon">
						<svg-icon icon-class="icon icon--inline x15" icon-name="icon-doc" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
                    </div>
                    <div class="profile_blockWidget-text gorizontal">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Соглашение об<br>управлении счётом
                        </div>
                        <div class="profile_blockWidget-ico">
                            <a href="http://master.forexinvest.com/files/agreement.pdf" target="_blank">
								<svg-icon icon-class="icon icon--inline x15" icon-name="icon-stash" icon-size="0 0 56 56" icon-fill="#FFFFFF"></svg-icon>
							</a>
                        </div>
                    </div>
                </div>
				<div class="profile_blockWidget-chatForms" ref="forms_contact">
					<div class="contactWidget-title">
						<div class="contactWidget-titleText" @click="closeCallbackWidget">
							<svg-icon icon-class="icon icon--inline x15" icon-name="icon-phone" icon-size="0 0 48 48" icon-fill="#FFFFFF"></svg-icon>
							Заказать обратный звонок
						</div>
					</div>
					<div class="contactWidget-title" @click="closeCallbackWidget">
						<div class="contactWidget-titleText">
							<svg-icon icon-class="icon icon--inline x15" icon-name="icon-coin" icon-size="0 0 42 42" icon-fill="#FFFFFF"></svg-icon>
							Инвестировать
						</div>
					</div>
				</div>
                <div class="profile_blockWidget profile_blockWidget_vertikal">
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Прогнозируемая доходность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            15-20% годовых 5-7% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            25-35% годовых 10-12% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            40-55% годовых 15-20% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            50+ % годовых 25-30% волатильность
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_big">
                    <div class="profile_blockWidget-bigIcon-font">
						<svg-icon icon-class="icon icon--inline x2" icon-name="icon-user" icon-size="0 0 75 75" icon-fill="#cae9ff"></svg-icon>
                    </div>
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-wrap">
                            <div class="profile_blockWidget-title">
                                Перейти на страницу<br>к доверительно<br>
                                управляющего активами
                            </div>
                        </div>
                        <div class="profile_blockWidget-ico">
                            <router-link :to="{name: 'profile'}" target="_blank">
							<svg-icon icon-class="icon icon--inline" icon-name="icon-arrow-next" icon-size="0 0 22 22" icon-fill="#ffffff"></svg-icon>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_vertikal" style="margin-bottom:0px">
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Часто задаваемые вопросы
                        </div>
                    </div>
                    <accordion
                        :dropdown="false"
                        :icon="'custom'"
                        :caretAnimation="{
                            duration: '.6s',
                            timerFunc: 'ease-in-out',
                        }"
                        :slide="{
                            duration: '.9s',
                            timerFunc: 'ease',
                        }">

                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Как инвестировать?
                                </div>
                            </div>
							<svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
							<svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <ol>
                                    <li>Изучить условия инвестирования и соглашение об управлении счетом.
                                        Обсудить с управляющим активом варианты управления - выработать
                                        совместно стиль управления. <router-link :to="{name: 'profile'}" target="_blank"> Связаться с управляющим актива</router-link>.
                                    </li>
                                    <li>Изучить информацию о провайдере ликвидности GC Exchange Limited
                                        на сайте компании - <a class="color-green" href="http://www.gc.exchange" target = "_blank">http://www.gc.exchange</a>. Провайдер лицензирован
                                        Британским регулятором FCA.
                                    </li>
                                    <li>Открыть индивидуальный торговый счет у провайдера ликвидности GC Exchange Limited. Мы поможем заполнить необходимые формы и подробно проконсультируем по всем процедурам. Открытие счета как правило занимает до 7 дней. Связаться с специалистом можно в чате или заказав обратный звонок.
                                    </li>
                                    <li>После оформления и открытия индивидуального торгового счета необходимо его пополнить путем перевода денежных средств со своего банковского расчетного счета.
                                    </li>
                                    <li>Заключить с управляющим активом соглашение об управлении счетом. </li>
                                    <li>Провайдер ликвидности GC Exchange Limited предоставит ежедневные и ежемесячные выписки по счету по электронной почте.
                                    </li>
                                    <li>Отчетный период 1 раз в месяц.</li>
                                </ol>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Список документов необходимых инвестору для открытия индивидуального торгового счёта
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Для физических лиц:</h3>
                                <ul><li>Для граждан РФ: <br>
                                        <ol>
                                            <li>
                                                скан-копии нотариально заверенного перевода на английский язык следующих документов: паспорт РФ (1 стр.+ прописка), заграничный паспорт РФ, водительское удостоверение, счет на оплату коммунальных платежей по тому адресу, где Вы зарегистрированы;
                                            </li>
                                            <li>
                                                реквизиты банковского счета в той валюте, что Вы выбираете при открытии торгового счета: USD, EUR, GBP;
                                            </li>
                                        </ol>
                                    </li>
                                    <li>Для граждан других государств: <br>
                                        <ol><li>скан-копии: паспорт, квитанция на оплату коммунальных платежей по месту регистрации, указанной в регистрационной форме;</li></ol>
                                    </li>
                                </ul>
                                <h3>Для юридических лиц:</h3>
                                <ol>
                                    <li>
                                        скан-копии нотариально заверенного перевода на английский язык регистрационных документов компании, для которой открывается торговый счет;
                                    </li>
                                    <li>
                                        скан-копии документов учредителей компании: <br/>

                                        Для граждан РФ.<br/>

                                        скан-копии нотариально заверенного перевода на английский язык следующих документов: паспорт РФ (1 стр.+ прописка), заграничный паспорт РФ, водительское удостоверение, счет на оплату коммунальных платежей по тому адресу, где Вы зарегистрированы.<br/>

                                        Для граждан других государств:<br/>паспорт, квитанция на оплату коммунальных платежей по месту прописки, указанной в регистрационной форме;
                                    </li>
                                    <li>
                                        реквизиты банковского счета компании в той валюте, что Вы выбираете при открытии торгового счета: USD, EUR, GBP;
                                    </li>
                                </ol>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Документы,  которые регулируют взаимоотношения между инвестором,  управляющим активами и провайдером ликвидности
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <ol>
                                    <li>
                                        <a class="color-green" href="https://iqquantum.com/files/Individual Account GCE July 2019_2.pdf" target="_blank">Individual Account GCE</a>
                                    </li>
                                    <li>
                                        <a class="color-green" href="https://iqquantum.com/files/GCEL Terms of Business.pdf" target="_blank">GCEL Terms of Business</a>
                                    </li>
                                    <li>
                                        <a class="color-green" href="https://iqquantum.com/files/GC EX Fee Payment Authorisation Form AD.pdf" target="_blank">GC EX Fee Payment Authorisation</a>
                                    </li>
                                    <li>
                                        <a class="color-green" href="https://iqquantum.com/files/Funds Withdrawal Request.pdf" target="_blank">Funds Withdrawal Request</a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Сколько по времени занимает открытие индивидуального торгового счёта?
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Открытие индивидуального торгового счёта занимает до 7 рабочих дней</h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Ввод/вывод средств
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Вы можете переводить средства на индивидуальный торговый счёт со своего счёта, открытого в любом банке.</h3>
                                <h3>Чтобы вывести средства со своего счета в GC Exchange Limited, вам необходимо будет заполнить и подписать форму вывода средств и отправить ее в операционный отдел GC Exchange Limited</h3>
                                <h3><a class="color-green" href="https://iqquantum.com/files/Funds Withdrawal Request.pdf" target="_blank">Funds Withdrawal Request</a></h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Сколько идет валютный банковский перевод из-за рубежа?
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Сроки прохождения платежей зависят от правил исполнения платежей, установленных в банках плательщиков, а также от количества банков, участвующих в цепочках платежей. Обычно срок составляет от 2 до 7 рабочих дней. В редких случаях, когда перечисление средств осуществляется из филиала небольшого банка, который, в свою очередь, исполняет платеж еще через несколько банков, срок перечисления средств может достигать 10 рабочих дней.</h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Права и доступ к счету
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Провайдер ликвидности GC Exchange Limited предоставит ежедневные и ежемесячные выписки по счету по электронной почте, таким образом вы всегда получаете актуальную информацию о состоянии своего счета.

Вы передаёте доступ к управляющему активами только для управления своим торговым счётом.</h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Почему мы работаем с провайдером ликвидности
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Работа с провайдером ликвидности на прямую позволяет избежать дополнительные расходы, связанные  с ведением торговых операций, в частности спрэд у провайдера ликвидности значительно ниже чем предлагают большинство брокеров. Провайдер ликвидности работает на прямую с банками и финансовыми институтами и имеет все необходимые лицензии, что делает исполнение всех операций качественным и своевременным.</h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Вознаграждение управляющего активами
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Инвестор дает согласие выплачивать один раз в месяц следующие комиссионные вознаграждения, начисляемые Управляющему счетом:</h3>
                                <ol>
                                    <li>стимулирующее вознаграждение в размере 33,3 % от прибыли;</li>
                                    <li>плата за управление в размере 3,0 % годовых от суммы чистых активов под управлением.</li>
                                </ol>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_question">
                        <accordion-item>
                            <div slot="title">
                                <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_question">
                                    Отчетный период
                                </div>
                            </div>
                        <svg-icon slot="icon-open" icon-class="icon icon--inline x2" icon-name="icon-icon-up" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <svg-icon slot="icon-closed" icon-class="icon icon--inline x2" icon-name="icon-icon-down" icon-size="0 0 14 14" icon-fill="#ADC4E1"></svg-icon>
                        <div slot="content">
                            <div class="profile_blockWidget-text_content">
                                <h3>Отчетный период 1 раз в месяц </h3>
                            </div>
                        </div>
                        </accordion-item>
                    </div>
                    </accordion>
                </div>
            </scrollbar>
        </div>
        <div class= "grid__main-content">
            <scrollbar class="scrollContent">
                <div class="profile_blockWidget-header">
                    <div class="profile_blockWidget-header_text">
                        <h1>Условия инвестирования</h1>
                        <div>Мы работаем только с квалифицированными инвесторами, нерезидентами США. Минимальный начальный баланс счета 100 000 USD или эквивалент в Euro, Pounds, Swiss Frank. Управление осуществляется только через провайдеров ликвидности, Вы предоставляете доступ только для управления. Management Fee - 3%, Success Fee - 33,3 %, от HWM, расчеты производятся один раз в месяц.</div>
                    </div>
                    <div class="profile_blockWidget-header_conditionsWrap">
                        <div class="profile_blockWidget-header_conditionsRow">
                            <div class="profile_blockWidget-header_conditionsItem">
                                Мам счёт
                                <des icon="icon-info" icon-class="icon icon--inline x2" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'МАМ счет – дословно “Управляющий несколькими счетами” (Multi Account Manager), т.е— это технология, позволяющая управляющему активами эффективно управлять неограниченным количеством счетов инвестора. МАМ счет это одна из современных форм сотрудничества между управляющим и инвесторами, при которой все средства инвестора хранятся на его персональном счете, а управляющий имеет доступ только для управления.'"></des>
                            </div>

                        </div>
                        <div class="profile_blockWidget-header_conditionsRow">
                            <div class="profile_blockWidget-header_conditionsItem">
                                Доступ к счёту для управления
                                <des icon-class="icon icon--inline x2" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'Все средства инвестора хранятся на его персональном торговом счете у провайдера ликвидности Global Markets Group, где инвестор может 24 часа в сутки 7 дней в неделю видеть и контролировать состояние своего счета в личном кабинете предоставленным провайдером и в любой момент может запросить вывод своих средств на расчетный счет в банке, который будет осуществлен в течении 24 часов. Управляющий имеет доступ только для управления торговым счетом Инвестора и заключения торговых сделок от имени Инвестора.'"></des>
                            </div>
                            <div class="profile_blockWidget-header_conditionsItem">
                                Расчёт один раз в месяц
                                <des icon-class="icon icon--inline x2" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'Комиссия за управление (Management fee) и стимулирующее вознаграждение (success fee) рассчитываются ежемесячно. В течении трех дней с даты окончания каждого месяца Управляющий счетом составляет расчетный документ, где указывает размер обоих вознаграждений, и направляет его Клиенту. Клиент подтверждает, что оба вознаграждения должны быть выплачены в течение пяти календарных дней с даты выставления счета. Все эти платежи  должны переводиться на счет Управляющего счетом. Банковские реквизиты указываются в расчетном документе, направляемом Управляющим счетом.'"></des>
                            </div>
                        </div>
                        <div class="profile_blockWidget-header_conditionsRow">
                            <div class="profile_blockWidget-header_conditionsItem">
                                Management FEE 3% годовых от AUM
                                <des icon-class="icon icon--inline x2" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'MANAGEMENT FEE от AUM - плата за управление активами в размере 3,0 % годовых от суммы чистых активов под управлением.'"></des>
                            </div>
                            <div class="profile_blockWidget-header_conditionsItem">
                                Success FEE от 33.3% от<br>суммы превышающей HWM
                                <des icon-class="icon icon--inline x2" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'SUCCESS FEE от HWM - стимулирующее вознаграждение в размере 33,3 % от прибыли.'"></des>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget-staticText-wrap">
                    <div class="profile_blockWidget-staticText">
                        Вам необходимо открыть персональный брокерский счёт у прайм-брокера (провайдера ликвидности)
                    </div>
                    <div class="profile_blockWidget-header_conditionsRow">
                        <div class="profile_blockWidget-header_conditionsItem profile_blockWidget-header_conditionsItem-big">
                            <img :src="require('../assets/img/gce_logo.png')" />
                            <a href="http://www.gc.exchange" target="_blank">Перейти на сайт</a>
                        </div>
                        <div class="profile_blockWidget-header_conditionsItem profile_blockWidget-header_conditionsItem-big">
                            <div class="profile_blockWidget-header_conditionsItem-text">
                                <a href="https://iqquantum.com/files/agreement.pdf" target="_blank"><svg style="width:60px;height:60px" viewBox="0 0 24 24">
                                    <path fill="#CAE9FF" d="M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z" />
                                </svg></a>
                                Соглашение об<br>управлении счётом
                            </div>
                            <div class="profile_blockWidget-header_conditionsItem-blockIcon">
                                <a href="https://iqquantum.com/files/agreement.pdf" target="_blank">
									<svg-icon icon-class="icon icon--inline x2" icon-name="icon-stash" icon-size="0 0 24 24" icon-fill="#ffffff"></svg-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget-mainText-wrap">
                    <div class="profile_blockWidget-mainText-title">
                        Порядок открытия счёт у провайдера GC Exchange Limited <br>и управление активами
                    </div>
                    <div class="profile_blockWidget-mainText">
                        <ol>
                            <li>Изучить условия инвестирования и соглашение об управлении счетом. Обсудить с управляющим активом варианты управления - выработать совместно стиль управления. <router-link :to="{name: 'profile'}" target="_blank">
                                <span class="color-green">Связаться с управляющим актива</span></router-link></li>
                            <li>Изучить информацию о провайдере ликвидности GC Exchange Limited на сайте компании - <a class="color-green" href="http://www.gc.exchange" target="_blank">http://www.gc.exchange</a>. Провайдер лицензирован Британским регулятором.</li>
                            <li>Открыть индивидуальный торговый счет у провайдера ликвидности GC Exchange Limited. Мы поможем заполнить необходимые формы и подробно проконсультируем по всем процедурам. Открытие счета как правило занимает до 7 дней. Связаться с специалистом можно в чате или заказав обратный звонок.</li>
                            <li>После оформления и открытия индивидуального торгового счета необходимо его пополнить путем перевода денежных средств со своего банковского расчетного счета.</li>
                            <li>Заключить с управляющим активом соглашение об управлении счетом.</li>
                            <li>Провайдер ликвидности GC Exchange Limited предоставит ежедневные и ежемесячные выписки по счету по электронной почте.</li>
                            <li>Отчетный период 1 раз в месяц.</li>
                        </ol>
                    </div>
                </div>
            </scrollbar>
        </div>
        <div class="grid__chat">
            <div class="profile_blockWidget profile_blockWidget-chat">
                <div class="profile_blockWidget-chatWidget">
                    <chat-live :heightBlock="heightContactBlock" :person="'vd'"></chat-live>
                </div>
            </div>
        </div>
		<div v-if="showCallbackWidget" class="callBackWidget">
			<callback-widget  @closeWidget="closeCallbackWidget"/>
		</div>
    </div>
</template>

<script>
import LiveChat from './chat/chat-live-trader';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CallBackWidget from './ui-components/callback-widget';
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import Description from './ui-components/description';
import svgIcon from './ui-components/svg-icon';
	export default {
		components: {
            "chat-live":LiveChat,
            "scrollbar":VuePerfectScrollbar,
            "accordion-item":BulmaAccordionItem,
            "accordion":BulmaAccordion,
            "des":Description,
            "callback-widget":CallBackWidget,
			"svg-icon":svgIcon
	    },
		props: [],
		data() {
			return {
				showCallbackWidget:false
			};
		},
		computed: {

		},
		methods: {
			closeCallbackWidget() {
				this.showCallbackWidget = !this.showCallbackWidget
			}
		}

	};
</script>
<style lang="less" scoped>
/*.managment
{
    width: 1012px;
    margin: 0 auto;

    &__blocks
    {
        display: flex;
        margin-bottom: 1px;

        &-left
        {
            max-width: 303px;
            margin-right: 1px;
        }

        &-right
        {
            max-width: 303px;
        }

        &-item
        {
            padding: 24px;
            background: #fff;
            border-radius:4px;
            font-family: Montserrat;
            font-size: 13px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.54;
            letter-spacing: 0.4px;
            text-align: left;
            color: #506b89;
            text-transform: uppercase;
            margin-bottom: 1px;

            &-img
            {
                height: 120px;
                cursor: pointer;
                display: flex;
                align-items: center;
                box-sizing: border-box;
            }
        }
    }

    &__title
    {
        font-family: Montserrat;
        font-size: 40px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
        text-transform: uppercase;
        margin: 52px 0;
    }

    &__content
    {
        display: flex;

        &-inv
        {
            margin-top:62px;
        }

        &-left
        {
            width: 608px;
            margin-right: 44px;

            &-inv
            {
                h2
                {
                    margin-bottom: 16px !important;
                }
            }

            p
            {
                font-family: Roboto;
                font-size: 16px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                margin-bottom: 32px;
            }

            span
            {
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                display: block;
                margin-bottom: 32px;
            }

            h2
            {
                font-family: Montserrat;
                font-size: 23px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.39;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                text-transform: uppercase;
                margin-bottom: 32px;
            }

            h3
            {
                font-family: Montserrat;
                font-size: 16px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                text-transform: uppercase;
                margin-bottom: 12px;

            }
        }
        &-right {
            width: 360px;
        }
    }

    &__list-item
    {
        font-family: PTSerif-Caption;
        font-size: 15px;
        font-weight: normal;
        font-style: italic;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        text-align: left;
        color: #cae9ff;
        margin-bottom: 40px;
        padding-left: 26px;
        border-left: 1px solid #adc4e1;
    }

    &__line
    {
        width: 24px;
        height: 2px;
        margin: 52px 0;
        background-image: linear-gradient(to left, #00ffbb, #00e1ff);

        &-inv
        {
           margin: 16px 0;
        }
    }
}*/

.scrollContent {
    height: calc(100vh - 98px);
    overflow: auto;
}
.profile_blockWidget {
    display: flex;
    width: 360px;
    background: #3D536B;
    margin-bottom: 4px;
    &:last-child {
        margin-bottom: 0px;
    }
    &-image {
        display: flex;
        border-bottom: solid 1px #293546;
        height: 179px;
        display: flex;
        align-items: center;
        padding-left: 12px;
    }
    &-imageItem {
        height: 155px;
        width: 109px;
        margin-right: 12px;
    }
    &-header {
      background: #3D536B;
      width: 100%;
      //height: 160px;
      //padding: 23px 0px 0px 0px;
      box-sizing: border-box;
      &_text {
        height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 23px;
        h1 {
          font-size: 35px;
          font-family: Montserrat;
          font-weight: bold;
        }
        div {
          font-family: Roboto;
          font-size: 20px;
          color:#ADC4E1;
        }
      }

      &_conditionsWrap {
          margin-top: 23px;
      }
      &_conditionsRow {
          width: 100%;
          display: flex;
          border-top: 1px solid #293546;
      }
      &_conditionsItem {
          flex-basis: 50%;
          flex-grow: 1;
          height: 70px;
          padding-left: 23px;
          padding-right: 23px;
          font-family: Arimo;
          font-size: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-right: 1px solid #293546;
          &:last-child {
              border-right:none;
          }
          &-big {
            height: 110px;
            img {
                width: 323px;
            }
          }
          &-text {
              display: flex;
              svg {
                  margin-right: 12px;
              }
          }
      }
    }
    &-mainText {
        font-size: 21px;
        font-family: Roboto;
        color:#ADC4E1;
        line-height: 1.5;
        padding-bottom: 23px;
		ol {
			padding-left: 40px;
			margin-top: 20px;
			list-style-type: decimal;
		}
        li {
            margin-bottom: 18px;
        }
        &-title {
            height: 110px;
            font-family: Montserrat;
            font-weight: bold;
            font-size: 25px;
            display: flex;
            align-items: center;
            padding-left: 23px;
            line-height: 1.5;
            border-bottom: 1px solid #293546;
        }
        &-wrap {
            background: #3D536B;
            margin-top: 4px;
        }
    }
    &-staticText {
        font-size: 20px;
        font-family: Roboto;
        color:#ADC4E1;
        height: 70px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &-wrap {
            background: #3D536B;
            margin-top: 4px;
        }
    }
    &-center {
        display: flex;
        margin-top: 4px;
        height: calc(100vh - 275px);
        overflow: hidden;
        //margin-bottom: 4px;
    }
    &-chat {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: hidden;
        background: #293546;
    }
    &-chatWidget {
        //flex-grow: 1;
        //max-height: 100%;
        //flex-basis: 100%;
    }
    &-chatForms {
        //flex-grow: 1;
        //flex-basis: 100%;
    }
    &-profitDeals {
        display: flex;
        justify-content: space-between;
        &_wrapData {
            padding: 8px 16px;
        }
        &-title {
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.18;
            letter-spacing: .4px;
            text-transform: uppercase;
            color: #fff;
            margin-top: 4px;
        }
        &-chart {
            flex-grow: 1;
            max-width: 180px;
            padding: 8px 16px;
            display: flex;
            justify-content: flex-end;
        }
    }
    &-profitWidget {
        min-width: 360px;
        height: calc(100vh - 264px);
        overflow: auto;
    }
    &-chart {
        max-width: 100%;
        height: calc(100vh - 804px);
        flex-grow: 1;
        &:first-child {
            margin-bottom: 3px;
        }
    }
    &-chartWrap {
        flex-grow: 1;
        margin-left: 4px;
        height: calc(100vh - 275px);
        overflow: auto;
    }
    &-chartPrognosis {
        display: flex;
        width: 100%;
        max-height: 245px;
        border-top: solid #293546 4px;
        &_item {
            flex-basis: 50%;
            flex-grow: 1;
            height: 245px;
            &:first-child {
                border-right: solid #293546 4px;
            }
        }
    }
    &-trader {
        align-items: center;
        display: flex;
        width: 45%;
        padding-right: 40px;
        box-sizing: border-box;
        justify-content: space-between;
        border-right: solid #293546 1px;

    }
    &-traderAva {
        width: 125px;
        height: 125px;
        border-radius: 70px;
        overflow: hidden;
    }
    &-traderName {

    }
    &-name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }
    &-status {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 16px;
        letter-spacing: 0.4px;
        color: #ADC4E1;
    }
    &-traderSkils {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        &-wrap {
            display: flex;
            justify-content: space-between;
            max-width: 100%;
            padding-left: 23px;
        }
    }
    &-traderSkilsUl {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* or 143% */
        letter-spacing: 0.4px;
        max-width: 45%;
        margin-left: 23px;
    }
    &_vertikal {
        display: block;
    }
    &_big {
        height: 120px;
        &-column {
            flex-direction: column;
        }
    }
    &_mini {
        height: 70px;
    }
    &-text {
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &_content {
            font-family: Montserrat;
            font-size: 13px;
            color:#CCE0F8;
            li {
                margin-bottom: 8px;
            }
            h3 {
                margin-top: 8px;
                margin-bottom: 8px;
            }
        }
        &_prognosis {
           border-top: 1px solid #293546;
        }
        &_question {
            //flex-direction: row;
            border-top: 1px solid #293546;
            i {
                color:#ADC4E1;
            }
        }
    }
    &-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #293546;
    }
    &-col {
        width: 50%;
        flex-grow: 1;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid #293546;
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 14px;
        /* identical to box height, or 140% */
        letter-spacing: 0.4px;
        color: #FFFFFF;
        &:last-child {
           border-right:none;
        }
    }
    &-title {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        /* identical to box height, or 167% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 12px;
        &_noBottom {
            margin-bottom: 0;
        }
        &_prognosis {
            font-family: Arimo;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            /* or 267% */
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #00FFD0;
        }
        &_question {
            font-family: Roboto;
            font-size: 13px;
            color:#ADC4E1;
            text-transform: none;
        }
    }
    &-subtitle {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        a {
           color: #ADC4E1;
        }
    }
    &-bigIcon {
        padding: 20px;
        border-right: 1px #293546 solid;
        &-font {
            padding: 20px;
            border-right: 1px #293546 solid;
            font-size: 75px;
            color:#CAE9FF;
        }
    }
    &-ico {
        color:#718DA8;
        cursor: pointer;
    }
}
.contactWidget {
    flex-direction: column;
    overflow: hidden;
    &:last-child {
        margin-bottom: 0px;
    }
    &-desc {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        margin-top: 12px;
    }
    &-submit {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 24px;
        /* identical to box height, or 200% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-top: 12px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    &-title {
        padding: 12px;
        background: #3D536B;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 1;
        //border-bottom: #293546  1px solid;
        svg {
            color:#718DA8;
            cursor: pointer;
        }
    }
    &-titleText {
        display: flex;
        align-items: center;
        svg {
            color:#fff;
            font-size: 24px;
            margin-right: 8px;
            margin-bottom: -4px;
        }
    }
    &-form {
        padding-left: 12px;
        display: flex;
        flex-direction: column;
    }
    &-formInput {
        border-bottom: 1px solid #35485E;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        margin-top: 15px;
        padding-bottom: 4px;
        outline: none;
        /* identical to box height, or 127% */
        color: #CCE0F8 !important;
    }
    &-dataItem {
        padding: 12px;
    }
    &-dataText {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
        &_title {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 20px;
            color: #ADD4E1;
        }
    }
    &-dataWrap {
        z-index: 0;
        overflow: hidden;
    }
}
input[type="text"]::placeholder { color: #CCE0F8; }
.black-overlay {
    background: #293546 !important;
}
.gorizontal {
    flex-direction: row;
    width: 100%;
    align-items: center;
}
.vertical {
    flex-direction: column
}
.profile-scroll {
    max-height: 100%;
}
ul.profile_blockWidget-traderSkilsUl {
    list-style: disc outside !important;
}
ul.profile_blockWidget-traderSkilsUl > li:first-child {
    margin-bottom: 30px;
}
.contactWidget {
	&-title {
		padding: 12px;
		background: #3D536B;
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		z-index: 1;
		margin-bottom: 3px;
		//border-bottom: #293546  1px solid;
		i {
			color:#718DA8;
			cursor: pointer;
		}
	}
	&-titleText {
		display: flex;
		align-items: center;
		i {
			color:#fff;
			font-size: 24px;
			margin-right: 8px;
			margin-bottom: -4px;
		}
	}
}

.callBackWidget {
	width: calc(100vw - 75px);
	height: calc(100vh - 98px);
	position: absolute;
	background: rgba(0,0,0,0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 7;
}

@media screen and (max-width: 1600px) {
    .grid__chat {
      display: none;
    }
  }
</style>
